import { useQuery } from "@tanstack/react-query";

import { compilationListQuery } from "../queries";

export function useCompilationList() {
  return useQuery(compilationListQuery());
}
